import { useQuery } from '@tanstack/react-query';
import { getPortfolioDetails } from 'services/portfolios/portfolioService';

const useGetPortfolioBySA = (serviceAgreementId: string, isEnabled: boolean) => {
  return useQuery({
    queryKey: ['useGetPortfolioBySA', serviceAgreementId],
    queryFn: () => getPortfolioDetails(serviceAgreementId),
    enabled: isEnabled && !!serviceAgreementId,
  });
};

export default useGetPortfolioBySA;
